import React, { Component, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import mastercard_logo from '../images/mastercard.png'
import wechatpay_logo from '../images/wechatpay.png'
import wechatpayAliPay_logo from '../images/wechatAlipay.png'
import fps_logo from '../images/fpslogo.png'
import visacard_logo from '../images/visa.png'
import paypal_logo from '../images/paypal.png'
import { Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import {RadioGroup, Radio} from 'react-radio-group';
import FeeCalculator from '../../components/FeeCalculator';
import ArbitrationFeeTable from '../../components/ArbitrationFeeTable';
import PaymentAsia from './PaymentAsia';
import FPS from './FPS';
import { connect } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import withSizes from "react-sizes";
var commaNumber = require('comma-number');

const CLIENT = {
    sandbox: process.env.PAYPAL_CLIENT_ID_SANDBOX,
    production: process.env.PAYPAL_CLIENT_ID_PRODUCTION,
  };

const ENV = process.env.NODE_ENV === 'production'
? 'production'
: 'sandbox';

const styles = theme => ({
    paper:{
        width: '50%',
        margin: '0 Auto',
    },
    root: {
        // paddingLeft:'140px',
        // paddingRight:'140px'
        // padding:'20px'
        // justifyContent: 'center',
        // alignItems:'center',
        // align:'center'
    },
    button:{
        width: '50%',
        display: 'flex',
        margin: '0 Auto',
        //justifyContent: 'center',
    },
    buttonPay: {
        margin: theme.spacing.unit,
    },
    listItemText:{
        display: 'flex',
        justifyContent: 'center',
    },
    header:{
        align:"center"
    },
    menuItem: {
      '&:focus': {
        backgroundColor: theme.palette.primary.main,
        '& $primary': {
          color: theme.palette.common.white,
        },
      },
    },
    primary: {},
});

function createData(amountInDispute, fee) {
return { amountInDispute, fee};
}
  
const rows = [
      createData('At or below 1,000', '100.00'),
      createData('At or between 1,001 and 2,000', '200.00'),
      createData('At or between 2,001 and 5,000', '500.00'),
      createData('At or between 5,001 and 10,000', '1,000.00'),
      createData('At or between 10,001 and 15,000', '1,500.00'),
      createData('At or between 15,001 and 20,000', '2,000.00'),
      createData('At or between 20,001 and 50,000', '2,500.00'),
      createData('At or between 50,001 and 100,000', '5,000.00'),
      createData('At or between 100,001 and 150,000', '7,500.00'),
      createData('At or between 150,001 and 250,000', '12,500.00'),
      createData('At or between 250,001 and 500,000', '25,000.00'),
      createData('At or between 500,000 and 1,500,000', '37,500.00'),
      createData('At or between 1,5000,001 and 3,000,000', '75,000.00'),
      createData('At or between 3,000,001 and 10,000,000', '125,000.00'),
      createData('Over 10,000,000', '175,000.00'),
    ];

class Payment extends Component{

    state = {
        paymentMethod: null,
        userType: null,
        uniqueId: localStorage.getItem('token'),
        value: 0,
        total: 0
    }

    handleselectedPayment = (index) => {
        console.log('handleselectedPayment: '+index)
        this.setState({paymentMethod: index})
        console.log('handleselectedPayment state: '+this.state.paymentMethod)
    }

    handleCompleteStep(){
        this.props.handleComplete();
    }

    skipPaymentForClaimant = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/savePaymentDetails`;
    
        const skipPaymentForClaimants = {
            "payment_details":{
                "timestamp":"",
                "paid": "manually paid"
            },
            "userType":"claimant",
            "caseId":(''+this.props.caseData.caseId),
            "skipUniqueId": localStorage.getItem('skipUniqueId'),
            "skipToken": localStorage.getItem('skipToken')
        }

        axios.post(url, {
            ...skipPaymentForClaimants
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                alert("Failed to skip payment for claimant. Please contact HKAS.")
            }
            else{
                window.location.reload()
            }
        })
    }

    addCaseToKCashAccount = (skipToken, skipUniqueId) => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/addCaseToKCashAccount`;
    
        const addNewCaseToKCashAccount = {
            "caseId":(''+this.props.caseData.caseId),
            "skipUniqueId": skipUniqueId,
            "skipToken": skipToken
        }

        axios.post(url, {
            ...addNewCaseToKCashAccount
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                alert("Failed to add case for claimant. Please contact HKAS.")
            }
        })
    }

    componentWillMount(){
        console.log('the case is kind_of_claim: '+this.props.caseData.kind_of_claim)
        if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){
            if (this.props.caseData.a1 == 'sole'){

                if (this.props.caseData.a2 === 'vendor'){
                    this.setState({
                        value: parseInt(this.props.caseData.a15f)
                    })
                }
                else if (this.props.caseData.a2 === 'purchaser'){
                    this.setState({
                        value: parseInt(this.props.caseData.a16f)
                    })
                }

            }
            else if (this.props.caseData.a1 == 'seperate'){
                this.setState({
                    value: parseInt(this.props.caseData.a16f)
                })
            }

        }
        else if (this.props.caseData.kind_of_claim == 'money_lent'){
            this.setState({
                value: parseInt(this.props.total_outstanding_loan)
            })
        }
        else if (this.props.caseData.kind_of_claim == 'creditcard'){
            this.setState({
                value: parseInt(this.props.caseData.a38)
            })
        }
        else if (this.props.caseData.kind_of_claim == 'SalesOfGoods'){

            if (this.props.caseData.a2 == 'purchaser') {
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'seller') {
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }
        else if (this.props.caseData.kind_of_claim == 'serviceDispute'){

            if (this.props.caseData.a2 == 'purchaser') {
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'provider_of_services') {
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }

        else if (this.props.caseData.kind_of_claim == 'insuranceDispute'){

            if (this.props.caseData.a2 == 'purchaser') {
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'seller') {
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }
        else if (this.props.caseData.kind_of_claim == 'other_dispute'){
            console.log('the case is other duspute with balance: '+this.props.caseData.a19)
            this.setState({
                value: parseInt(this.props.caseData.a19)
            })
        }

        console.log('121 value: '+this.state.value);
        
        setTimeout(()=>{
            if (this.state.value <= 1000){
                this.setState({
                    total: 100
                })
            }
            else if (this.state.value >= 1001 &&
                this.state.value <= 2000){
                this.setState({
                    total: 200
                })
            }
            else if (this.state.value >= 2001 &&
                this.state.value <= 5000){
                this.setState({
                    total: 500
                })
            }
            else if (this.state.value >= 5001 &&
                this.state.value <= 10000){
                this.setState({
                    total: 1000
                })
            }
            else if (this.state.value >= 10001 &&
                this.state.value <= 15000){
                this.setState({
                    total: 1500
                })
            }
            else if (this.state.value >= 15001 &&
                this.state.value <= 20000){
                this.setState({
                    total: 2000
                })
            }
            else if (this.state.value >= 20001 &&
                this.state.value <= 50000){
                this.setState({
                    total: 2500
                })
            }
            else if (this.state.value >= 50001 &&
                this.state.value <= 100000){
                this.setState({
                    total: 5000
                })
            }
            else if (this.state.value >= 100001 &&
                this.state.value <= 150000){
                this.setState({
                    total: 7500
                })
            }
            else if (this.state.value >= 150001 &&
                this.state.value <= 250000){
                this.setState({
                    total: 12500
                })
            }
            // else if (this.state.value >= 250001 &&
            //     this.state.value <= 500000){
            //     this.setState({
            //         total: 25000
            //     })
            // }
            // else if (this.state.value >= 500001 &&
            //     this.state.value <= 1500000){
            //     this.setState({
            //         total: 37500
            //     })
            // }
            // else if (this.state.value >= 1500001 &&
            //     this.state.value <= 3000000){
            //     this.setState({
            //         total: 75000
            //     })
            // }
            // else if (this.state.value >= 3000001 &&
            //     this.state.value <= 10000000){
            //     this.setState({
            //         total: 125000
            //     })
            // }
            else if (this.state.value >= 250001){
                this.setState({
                    total: 25000
                })
            }
        },5000)
        
        console.log('182 total: '+this.state.total);
        console.log('payment this.state.uniqueId: '+this.state.uniqueId);
        console.log('payment this.props.claimantUniqueId: '+this.props.claimantUniqueId);
        console.log('payment this.props.respondentUniqueId: '+this.props.respondentUniqueId);
        
        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                userType : 'claimant'
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                userType : 'respondent'
            });
        }


        // skip payment

        let skipToken = localStorage.getItem('skipToken');
        let skipUniqueId = localStorage.getItem('skipUniqueId');
        if (skipToken && skipUniqueId){
                if (this.state.uniqueId == this.props.claimantUniqueId){
                    this.skipPaymentForClaimant();
                    this.addCaseToKCashAccount(skipToken, skipUniqueId); 
                }
        }
    }

    componentDidMount(){
        console.log('Payment handleComplete: '+JSON.stringify(this.props.handleComplete));
        console.log('caseData in payment: '+JSON.stringify(this.props.caseData));
        console.log('parseInt(this.props.caseData.a15f): '+parseInt(this.props.caseData.a15f))

        if((''+this.props.email).endsWith('@primecredit.com')){
            this.props.handleComplete()
        }
        
        if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){
            // if (this.props.caseData.a2 == 'purchaser'){
            //     this.setState({
            //         value: parseInt(this.props.caseData.a22)
            //     })
            // }
            // else if (this.props.caseData.a2 == 'vendor'){
            //     this.setState({
            //         value: parseInt(this.props.caseData.a22)
            //     })
            // }
            // else{
            //     if (this.props.caseData.a1 == 'sole'){

            //         if (this.props.caseData.a2 === 'vendor'){
            //             this.setState({
            //                 value: parseInt(this.props.caseData.a15f)
            //             })
            //         }
            //         else if (this.props.caseData.a2 === 'purchaser'){
            //             this.setState({
            //                 value: parseInt(this.props.caseData.a16f)
            //             })
            //         }

            //     }
            //     else if (this.props.caseData.a1 == 'seperate'){
            //         this.setState({
            //             value: parseInt(this.props.caseData.a16f)
            //         })
            //     }
            // }

            if (this.props.caseData.a1 == 'sole'){
                if (this.props.caseData.a2 === 'vendor'){
                    console.log('sole vendor value: '+this.props.caseData.a15f)
                    this.setState({
                        value: parseInt(this.props.caseData.a15f)
                    })
                }
                else if (this.props.caseData.a2 === 'purchaser'){
                    this.setState({
                        value: parseInt(this.props.caseData.a16f)
                    })
                }
            }
            else if (this.props.caseData.a1 == 'seperate'){
                this.setState({
                    value: parseInt(this.props.caseData.a16f)
                })
            }
            else if (this.props.caseData.a2 == 'purchaser'){
                this.setState({
                    value: parseInt(this.props.caseData.a22)
                })
            }
            else if (this.props.caseData.a2 == 'vendor'){
                this.setState({
                    value: parseInt(this.props.caseData.a22)
                })
            }
        }
        else if (this.props.caseData.kind_of_claim == 'money_lent'){
            this.setState({
                value: parseInt(this.props.total_outstanding_loan)
            })
        }
        else if (this.props.caseData.kind_of_claim == 'creditcard'){
            this.setState({
                value: parseInt(this.props.caseData.a38)
            })
        }
        else if (this.props.caseData.kind_of_claim == 'other_dispute'){
            this.setState({
                value: parseInt(this.props.caseData.a19)
            })
        }
        else if (this.props.caseData.kind_of_claim == 'SalesOfGoods'){
            if (this.props.caseData.a2 == 'purchaser'){
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'seller'){
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }
        else if (this.props.caseData.kind_of_claim == 'serviceDispute'){
            if (this.props.caseData.a2 == 'purchaser'){
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'provider_of_services'){
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }
        else if (this.props.caseData.kind_of_claim == 'insuranceDispute'){
            if (this.props.caseData.a2 == 'purchaser'){
                this.setState({
                    value: parseInt(this.props.caseData.a19h)
                })
            }
            else if (this.props.caseData.a2 == 'seller'){
                this.setState({
                    value: parseInt(this.props.caseData.a18d5)
                })
            }
        }
    }

    render(){
        const { classes } = this.props;
        
        const onSuccess = (payment) => {
           console.log("The payment was succeeded!", payment);

           var payment_details = {};

           var payment_details = {
               city: payment.address.city,
               country_code: payment.address.country_code,
               line1: payment.address.line1,
               line2: payment.address.line2,
               postal_code: payment.address.postal_code,
               recipient_name: payment.address.recipient_name,
               state: payment.address.state,
               cancelled: payment.cancelled,
               email: payment.email,
               paid: payment.paid,
               payerID: payment.payerID,
               paymentID: payment.paymentID,
               paymentToken: payment.paymentToken,
               returnUrl: payment.returnUrl,
               status: 'paid'
           };

            let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/savePaymentDetails`;
            let payload = {
                payment_details: payment_details,
                userType: this.state.userType,
                caseId: this.props.caseId
            }
            axios.post(url, payload)
            .then((response) => {
                if(response.data === 'error' || response.data === 'failed'){
                    throw (`login ${response.data}`);
                }
                //this.handleCompleteStep();
                this.props.handleComplete();
                // steps_completed 
                // let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/steps_completed`;
                // let payload = {
                //     step_completed: 5,
                //     userType: this.state.userType,
                //     caseId: this.props.caseId
                // }

                // axios.post(url, payload)
                // .then((response) => {
                //     if(response.data === 'error' || response.data === 'failed'){
                //         throw (`login ${response.data}`);
                //     }
                    
                //     // TODO 
                //     // send user to next step
                //     //this.props.modifyStepsCompleted({"verification":true,"choose_arbitrator":true,"read_pdf":true,"sign":true,"payment":true,"upload_docs":false,"newAccount":false});

                // })
                // .catch((error) => {
                //     console.log(error);
                // });

            })
            .catch((error) => {
                console.log(error);
            });

        }
 
        const onCancel = (data) => {
            console.log('The payment was cancelled!', data);
            
        }
 
        const onError = (err) => {
            console.log("Error!", err);
        }

        let env = 'production'; // you can set here to 'production' for production
        let currency = 'HKD'; // or you can set this value from your props or state
        //var total = 0; // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout

        
        const client = {
            // sandbox:    'ASQkIR_m-Fin-gujULVy5bcl22zbFznPtbUKmG4TpRSKB84xigbMwXljrri3rBmrhq3MtRwBb7ImpsiR'
            production:  'AarPpZyA16rySnFZqMks5HixP532ClcQjqnC-KBGlzQShxzQAWoNy_paEEXZ5vUKHSQf_paQc1UaNI4Q',
        }
        
        return(
        <div className={classes.root} style = {{marginBottom:'50px', padding:this.props.isDesktop?'50px':'20px'}}>
            <Typography style={{fontSize: '15px', marginBottom: '20px', textAlign:!this.props.isDesktop?'center':'', marginTop:'50px', color:'#B71C1C', fontWeight:'bold'}}>
                {this.context.t('Please select payment method')}:
            </Typography>
            
            <RadioGroup name="paymentMethodSelector" row selectedValue={this.state.selectedValue} onChange={this.handleselectedPayment} style={{fontSize: '12px', fontWeight:'bolder', marginTop:'30px'}}>

                 <img src={wechatpayAliPay_logo} style={{marginRight:'10px', width:'150px', height:'69px'}} />{this.context.t('WeChat Pay / AliPay')}<Radio value="mastercard" name="handleselectedPayment" style={{marginRight:'10px',marginLeft:'30px',}} /><br></br>

                 <img src={paypal_logo} style={{marginRight:'10px', width:'150px', height:'95px'}} />{this.context.t('PayPal / CreditCard')}<Radio value="paypal" name="handleselectedPayment" style={{marginRight:'10px',marginLeft:'30px',}} /><br></br>
                 
                 <img src={fps_logo} style={{marginLeft:'35px', width:'80px', height:'70px'}} /><span style={{ marginLeft:'90px' }}>{this.context.t('fps')}</span><Radio value="fps" name="handleselectedPayment" style={{marginRight:'10px',marginLeft:'77px',}} />

            </RadioGroup>
            
            <Table className={classes.root} fixedHeader={false}>
                <TableBody>
                    <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Dispute amount')}:</TableCell>
                        <TableCell className={classes.leftCell} align="right" style={{fontSize:'15px', marginRight:'10px'}}>HK${commaNumber(parseInt(this.state.value))}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Arbitration Fee')}:</TableCell>
                        <TableCell className={classes.leftCell} align="right" style={{fontSize:'15px', marginRight:'10px'}}>HK${commaNumber(parseInt(this.state.total))}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Final Total')}:</TableCell>
                        <TableCell className={classes.leftCell} align="right" style={{fontSize:'15px', marginRight:'10px'}}> HK${commaNumber(parseInt(this.state.total))}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <br></br>
                {this.state.paymentMethod == 'mastercard' && <PaymentAsia env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            
                {this.state.paymentMethod == 'visa' && <PaymentAsia env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            
                {this.state.paymentMethod == 'paypal' && <PaypalExpressBtn env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            
                {this.state.paymentMethod == 'fps' && <FPS env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            <br></br>
        </div>
        );
    }
}

// export default withStyles(styles)(Payment);

const mapStateToProps = (state, ownProps) => {

    let uniqueId = localStorage.getItem('token');
    let userType = '';
        if(state.caseInfo.caseData.claimantUniqueId == uniqueId){
            userType = 'claimant';
        }else if(state.caseInfo.caseData.respondentUniqueId == uniqueId){
            userType = 'respondent';
        }
  else{
    userType = "claimant";
  }
    if (state.caseInfo.caseData.agreement_type == 'EstateAgentDispute'){
        console.log('@verification state.caseInfo.caseData.a2@: '+state.caseInfo.caseData.a2 == 'vendor')
        if (state.caseInfo.caseData.a1  == 'seperate'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                email: state.caseInfo.caseData.namesOfA2[0].a11a,
                caseData: state.caseInfo.caseData,
                userType: userType,
                caseId: state.caseInfo.caseId,
                total_outstanding_loan: state.caseInfo.total_outstanding_loan,
            }
        }
        else if ((state.caseInfo.caseData.a2  == 'purchaser' || state.caseInfo.caseData.a2  == 'vendor') && state.caseInfo.caseData.a1  !== undefined){
            if (userType == 'claimant'){
                if (state.caseInfo.caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        // telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                        telephone: state.caseInfo.caseData.a3c,
                        email: state.caseInfo.caseData.a3b,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                        caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                }
                
                
            }
            else if (userType == 'respondent'){
                if (state.caseInfo.caseData.a2  == 'vendor'){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfVendors[0].a11b,
                        email: state.caseInfo.caseData.namesOfVendors[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                        caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                } 
                else{
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfPurchasers[0].a12j,
                        email: state.caseInfo.caseData.namesOfPurchasers[0].a12i,
                        caseData: state.caseInfo.caseData,
                        userType: userType, caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                }
            }
        }
        else{
            if (userType == 'claimant'){
                console.log('verification state.caseInfo.caseData.a3c: '+state.caseInfo.caseData.a3c)
                if (state.caseInfo.caseData.a3c !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.a3c,
                        email: state.caseInfo.caseData.a3b,
                        caseData: state.caseInfo.caseData,
                        userType: userType, caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                }
            }
            else if (userType == 'respondent'){
    
                if (state.caseInfo.caseData.namesOfVendors !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfVendors[0].a11b,
                        email: state.caseInfo.caseData.namesOfVendors[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                        caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                    
                }
                else if (state.caseInfo.caseData.namesOfPurchasers !== undefined){
                    
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfPurchasers[0].a12j,
                        email: state.caseInfo.caseData.namesOfPurchasers[0].a12i,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                        caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                    
                }
                else if (state.caseInfo.caseData.namesOfA2 !== undefined){
                    return {
                        claimantUniqueId: state.caseInfo.claimantUniqueId,
                        respondentUniqueId: state.caseInfo.respondentUniqueId,
                        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                        telephone: state.caseInfo.caseData.namesOfA2[0].a11b,
                        email: state.caseInfo.caseData.namesOfA2[0].a11a,
                        caseData: state.caseInfo.caseData,
                        userType: userType,
                        caseId: state.caseInfo.caseId,
                        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
                    }
                    
                }
            }
        }
        
    }
    else if (state.caseInfo.caseData.agreement_type == 'MoneyLent'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
            email: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.lender_email_address : state.caseInfo.caseData.borrower_email_address}`,
            caseData: state.caseInfo.caseData,
            userType: userType,
            caseId: state.caseInfo.caseId,
            total_outstanding_loan: state.caseInfo.total_outstanding_loan,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'creditcard'){
        
        return {
            claimantUniqueId: state.caseInfo.claimantUniqueId,
            respondentUniqueId: state.caseInfo.respondentUniqueId,
            isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
            telephone: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.a8c : state.caseInfo.caseData.a16b}`,
            email: `${state.caseInfo.userType == 'claimant' ? state.caseInfo.caseData.a8b : state.caseInfo.caseData.a16a}`,
            caseData: state.caseInfo.caseData,
            userType: userType,
            caseId: state.caseInfo.caseId,
            total_outstanding_loan: state.caseInfo.caseData.a38,
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'other_dispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a8c,
                email: state.caseInfo.caseData.a8b,
                caseData: state.caseInfo.caseData,
                userType: userType,
                caseId: state.caseInfo.caseId,
                total_outstanding_loan: state.caseInfo.total_outstanding_loan,
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a16b,
                email: state.caseInfo.caseData.a16a,
                caseData: state.caseInfo.caseData,
                userType: userType,
                caseId: state.caseInfo.caseId,
                total_outstanding_loan: state.caseInfo.total_outstanding_loan,
            }
        }
    }
    else if (state.caseInfo.caseData.agreement_type == 'SalesOfGoods' ||
             state.caseInfo.caseData.agreement_type == 'serviceDispute' || 
             state.caseInfo.caseData.agreement_type == 'insuranceDispute'){
        if (userType == 'claimant'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a8c,
                email: state.caseInfo.caseData.a8b,
                caseData: state.caseInfo.caseData,
                userType: userType,
                caseId: state.caseInfo.caseId,
                total_outstanding_loan: state.caseInfo.total_outstanding_loan,
            }
        }
        else if (userType == 'respondent'){
            return {
                claimantUniqueId: state.caseInfo.claimantUniqueId,
                respondentUniqueId: state.caseInfo.respondentUniqueId,
                isVerified: state.caseInfo[`${userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
                telephone: state.caseInfo.caseData.a16b,
                email: state.caseInfo.caseData.a16a,
                caseData: state.caseInfo.caseData,
                userType: userType,
                caseId: state.caseInfo.caseId,
                total_outstanding_loan: state.caseInfo.total_outstanding_loan,
            }
        }
    }

}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

const mapSizesToProps = (sizes) => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet: withSizes.isTablet(sizes),
    isDesktop: withSizes.isDesktop(sizes),
    isGtMobile: withSizes.isGtMobile(sizes),
    isGtTablet: withSizes.isGtTablet(sizes),
    isStTablet: withSizes.isStTablet(sizes),
    isStDesktop: withSizes.isStDesktop(sizes),
    isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
  });

Payment.contextTypes = {
    t: PropTypes.func
}

// export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Payment));

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withSizes(mapSizesToProps)(withStyles(styles)((Payment))));